<template>
    <div>
        <modal class="new-modal-small" :name="modal_name" transition="nice-modal-fade" :delay="100" height="auto" width="500" :min-width="200" :max-width="500" :pivot-y="0.5" :adaptive="true" :scrollable="true">
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #fff !important; height: 35em !important;">
                <img src="/static/images/delete_pop_icon.svg" style="height: 10rem !important" />
                <div class="mt-5">
                    <div class="mb-4" style="color:#f30d0d;font-size: 18px;">
                        <span v-if="group_type == 'investor' && investors_selected.length > 1">Delete Group of Investors</span> 
                        <span v-if="group_type == 'investor' && investors_selected.length == 1">Delete Group of Investor</span> 
                        <span v-if="group_type == 'banker' && investors_selected.length > 1">Delete Group of Bankers</span> 
                        <span v-if="group_type == 'banker' && investors_selected.length == 1">Delete Group of Banker</span> 
                        <span v-if="group_type == 'supplier' && investors_selected.length > 1">Delete Group of Suppliers</span> 
                        <span v-if="group_type == 'supplier' && investors_selected.length == 1">Delete Group of Supplier</span> 
                        <span v-if="group_type == 'board' && investors_selected.length > 1">Delete Group of Board Members</span> 
                        <span v-if="group_type == 'board' && investors_selected.length == 1">Delete Group of Board Member</span> 
                        <span v-if="group_type == 'shareholder' && investors_selected.length > 1">Delete Group of Share Holders</span> 
                        <span v-if="group_type == 'shareholder' && investors_selected.length == 1">Delete Group of Share Holder</span> 
                     </div>
                     <div>
                         <span class="fs-15 fw-600" v-if="group_type == 'investor' && investors_selected.length > 1">Are You Sure You Want To Delete Group Of Investors?</span> 
                         <span class="fs-15 fw-600" v-if="group_type == 'investor' && investors_selected.length == 1">Are You Sure You Want To Delete Group Of Investor?</span> 
                         <span class="fs-15 fw-600" v-if="group_type == 'banker' && investors_selected.length > 1">Are You Sure You Want To Delete Group Of Bankers?</span> 
                         <span class="fs-15 fw-600" v-if="group_type == 'banker' && investors_selected.length == 1">Are You Sure You Want To Delete Group Of Banker?</span> 
                         <span class="fs-15 fw-600" v-if="group_type == 'supplier' && investors_selected.length > 1">Are You Sure You Want To Delete Group Of Suppliers?</span> 
                         <span class="fs-15 fw-600" v-if="group_type == 'supplier' && investors_selected.length == 1">Are You Sure You Want To Delete Group Of Supplier?</span> 
                         <span class="fs-15 fw-600" v-if="group_type == 'board' && investors_selected.length > 1">Are You Sure You Want To Delete Group Of Board Members?</span> 
                         <span class="fs-15 fw-600" v-if="group_type == 'board' && investors_selected.length == 1">Are You Sure You Want To Delete Group Of Board Member?</span> 
                         <span class="fs-15 fw-600" v-if="group_type == 'shareholder' && investors_selected.length > 1">Are You Sure You Want To Delete Group Of Share Holders?</span> 
                         <span class="fs-15 fw-600" v-if="group_type == 'shareholder' && investors_selected.length == 1">Are You Sure You Want To Delete Group Of Share Holder?</span> 
                     </div>
                </div>
                <div class="d-flex align-items-center justify-content-center mt-6">
                    <button
                        type="button"
                        class="btn btn-new-primary-bordered"
                        style="box-shadow: none;min-width: 5rem;"
                        @click="hideDeleteInvestorsModal()"
                    >Cancel</button>
                    <button
                        type="button"
                        class="btn btn-new-primary ml-4"
                        style="box-shadow: none;min-width: 5rem;"
                        @click="deleteCompany"
                    >Delete Group</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>

export default ({
    props:['modal_name', 'investors_selected', 'group_type'],
    data(){
        return{

        }
    },
    methods:{
        hideDeleteInvestorsModal(){
            this.$modal.hide(this.modal_name);
            this.$emit('hideDeleteGroupsModal');
        },
        deleteCompany() {
            this.$modal.hide(this.modal_name);
            this.$emit('deleteGroupsSuccess');
        }
    }
})

</script>

<style scoped>
    .btn-primary-outline{
        color: #2b6ad0;
		border-radius: 5px;
		padding-left: 35px;
		padding-right: 35px;
		text-transform: none;
		font-weight: 500;
		line-height: 30px;
		box-shadow: none;
		border-color: 2px solid #2b6ad0;
		box-shadow: none !important;
		font-weight: 500;
    }
</style>
